<h2 class="lots-step__title">
  Elenco lotti articolo ({{ productToWorkOn?.quantity }})
</h2>
<div class="lots-step__divider"></div>

@if (productToWorkOn?.batches?.length) {
  <div class="lots-step__list">
    <div
      class="lots-step__row lots-step__header"
      [class.lots-step__row--manual]="productToWorkOn.is_manual_lot"
    >
      <div class="lots-step__cell lots-step__cell--reference">Articolo</div>
      @if (productToWorkOn.is_manual_lot) {
        <div class="lots-step__cell lots-step__cell--a">Lotto</div>
        <div class="lots-step__cell lots-step__cell--a">Quantità</div>
      } @else {
        <div class="lots-step__cell lots-step__cell--a">Settimana</div>
        <div class="lots-step__cell lots-step__cell--a">Anno</div>
        <div class="lots-step__cell lots-step__cell--a">Da..</div>
        <div class="lots-step__cell lots-step__cell--da">A..</div>
      }
      <div class="lots-step__cell lots-step__cell--status">Azione</div>
    </div>

    @for (
      lot of productToWorkOn.batches;
      track lot.supplier_certificate_batch_id
    ) {
      <div
        class="lots-step__row"
        [class.lots-step__row--manual]="productToWorkOn.is_manual_lot"
        [class.is-processed]="productToWorkOn.is_prepared"
      >
        <div class="lots-step__cell lots-step__cell--reference">
          @if (productToWorkOn.is_manual_lot) {
            {{ productToWorkOn.product_code.trim() }}${{ lot.manual_batch }}
          } @else {
            {{ productToWorkOn.product_code.trim() }}${{
              lot.batch_week | number: "2.0-0"
            }}{{ `${lot.batch_year}` | slice: -2 }}${{
              lot.serial_from | number: "2.0-0"
            }}{{ lot.serial_to | number: "2.0-0" }}
          }
        </div>

        @if (productToWorkOn.is_manual_lot) {
          <div class="lots-step__cell lots-step__cell--a">
            {{ lot.manual_batch }}
          </div>
          <div class="lots-step__cell lots-step__cell--a">
            {{ lot.quantity }}
          </div>
        } @else {
          <div class="lots-step__cell lots-step__cell--a">
            {{ lot.batch_week }}
          </div>
          <div class="lots-step__cell lots-step__cell--a">
            {{ lot.batch_year }}
          </div>

          <div class="lots-step__cell lots-step__cell--a">
            {{ lot.serial_from }}
          </div>
          <div class="lots-step__cell lots-step__cell--da">
            {{ lot.serial_to }}
          </div>
        }

        <div class="lots-step__cell lots-step__cell--status">
          @if (!this.completed) {
            <button
              type="button"
              class="articles-step__button"
              (click)="
                articleSelected.emit(productToWorkOn);
                batchSelected.emit(lot);
                triggerAction2(
                  productToWorkOn.supplier_certificate_product_id,
                  $event
                )
              "
            >
              <span class="articles-step__button-icon">
                <i class="bx bx-info-circle"></i>
              </span>
              <span>{{ hasBatchLabel }}</span>
            </button>
          } @else {
            <button
              type="button"
              class="articles-step__button"
              (click)="openBatch(productToWorkOn, lot)"
            >
              <span class="articles-step__button-icon">
                <i class="bx bx-folder"></i>
              </span>
              <span>{{ viewBatchLabel }}</span>
            </button>
          }
          @if (productToWorkOn.is_prepared) {
            <span class="lots-step__status-icon">
              <i class="bx bx-check"></i>
            </span>
          }
        </div>
      </div>
    }
    @if ((orderService.getRemainingQtyDuplicates ?? 0) > 0) {
      <div
        class="lots-step__row lots-step__row--remaining"
        [class.is-processed]="
          productToWorkOn.is_prepared &&
          orderService.getRemainingQtyDuplicates === 0
        "
      >
        <div class="lots-step__cell lots-step__cell--reference">
          <!-- {{ productToWorkOn.product_description }} -->
        </div>

        <div class="lots-step__cell lots-step__cell--a lots-step__remaining">
          <i class="bx bx-error-circle"></i>
          <span
            >Quantità rimanente:
            {{ orderService.getRemainingQtyDuplicates }}</span
          >
        </div>

        <div class="lots-step__cell lots-step__cell--status">
          @if (!this.completed) {
            <button
              type="button"
              class="articles-step__button"
              (click)="
                articleSelected.emit(productToWorkOn);
                triggerAction(
                  productToWorkOn.supplier_certificate_product_id,
                  $event
                )
              "
            >
              <span class="articles-step__button-icon">
                <i class="bx {{ batchActionIcon }}"></i>
              </span>
              <span>{{ actionLabel }}</span>
            </button>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <p class="lots-step__empty">Nessun lotto disponibile per questo articolo.</p>
}
